import { useState } from "react";
// import { Modal } from "react-bootstrap";
import { AboutForm } from "../form/about";

export const About = (props: any) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className="row">
			<div className="col">
				<div className="form-group">
					<p>{props.about?.about}</p>
				</div>
				<br />
				<div className="col">
					<div className="form-group">
						<label className="font-medium">Currency :</label>
						<p>{props.about?.currency_code}</p>
					</div>
					<br />
					<div className="form-group">
						<label className="font-medium">Rate Per Hour :</label>
						<p>{props.about?.hour}</p>
					</div>
					<br />
					<div className="form-group">
						<label className="font-medium">Rate Per Half An Hour :</label>
						<p>{props.about?.halfAnHour}</p>
					</div>
				</div>
			</div>
		</div>
	);
};
